import { Auth0Provider } from '@auth0/auth0-react';
import React, { ReactNode, Suspense, lazy } from 'react';
import constVars from '~/constants/constVars';
import auth0Config from '~/helpers/auth0Config';
import { getAuth0Audience } from '~/helpers/utils';
import { useCognitoFeatureFlagEnabled } from '~/hooks/useCognitoFeatureFlagEnabled';
import { Auth0AuthProvider } from './Auth0AuthProvider';

const CognitoAuthProvider = lazy(() =>
  import('./CognitoAuthProvider').then((m) => ({
    default: m.CognitoAuthProvider,
  }))
);

export { CognitoAuthEvent, useAuth } from './AuthContext';

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const shouldUseCognito = useCognitoFeatureFlagEnabled();

  const auth0Audience = getAuth0Audience();

  if (
    shouldUseCognito &&
    auth0Audience !== constVars.AUTH_INTERNAL_PROD.AUDIENCE
  ) {
    return (
      <Suspense>
        <CognitoAuthProvider>{children}</CognitoAuthProvider>
      </Suspense>
    );
  } else {
    return (
      <Auth0Provider {...auth0Config}>
        <Auth0AuthProvider>{children}</Auth0AuthProvider>
      </Auth0Provider>
    );
  }
};
